"use client";
import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import { useState, useMemo } from 'react';
import './calendar.css';
export const testEvents = [
    {
        "id": "1",
        "title": "Brian's Birthday",
        "date": "2026-01-22",
        "category": "personal"
    },
    {
        "id": "2",
        "title": "Brian's Birthday",
        "date": "2027-01-22",
        "category": "personal"
    }
];
// Helper: Format Date object to YYYY-MM-DD (Local time, no UTC shifts)
const formatDateKey = (date) => {
    const y = date.getFullYear();
    const m = String(date.getMonth() + 1).padStart(2, '0');
    const d = String(date.getDate()).padStart(2, '0');
    return `${y}-${m}-${d}`;
};
export const EventCalendar = ({ events = [] }) => {
    const [currentDate, setCurrentDate] = useState(new Date());
    const year = currentDate.getFullYear();
    const month = currentDate.getMonth(); // 0 - 11
    // Navigation Handlers
    const handlePrevMonth = () => {
        setCurrentDate(new Date(year, month - 1, 1));
    };
    const handleNextMonth = () => {
        setCurrentDate(new Date(year, month + 1, 1));
    };
    const handleToday = () => {
        setCurrentDate(new Date());
    };
    // Map events by date key ("YYYY-MM-DD") for O(1) lookup
    const eventsByDate = useMemo(() => {
        return events.reduce((acc, event) => {
            if (!acc[event.date]) {
                acc[event.date] = [];
            }
            acc[event.date].push(event);
            return acc;
        }, {});
    }, [events]);
    const monthNames = [
        "January", "February", "March", "April", "May", "June",
        "July", "August", "September", "October", "November", "December"
    ];
    const dayLabels = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
    // Grid Construction Logic
    const calendarCells = useMemo(() => {
        const firstDayOfMonth = new Date(year, month, 1);
        const daysInMonth = new Date(year, month + 1, 0).getDate();
        const startingDayOfWeek = firstDayOfMonth.getDay();
        const cells = [];
        // Padding cells before the 1st of the month
        for (let i = 0; i < startingDayOfWeek; i++) {
            cells.push({ isPadding: true, key: `pad-${i}` });
        }
        // Actual day cells
        const todayKey = formatDateKey(new Date());
        for (let day = 1; day <= daysInMonth; day++) {
            const cellDate = new Date(year, month, day);
            const dateKey = formatDateKey(cellDate);
            const dayEvents = eventsByDate[dateKey] || [];
            cells.push({
                isPadding: false,
                dayNumber: day,
                dateKey,
                events: dayEvents,
                isToday: todayKey === dateKey,
                key: dateKey
            });
        }
        return cells;
    }, [year, month, eventsByDate]);
    return (_jsxs("div", { className: "calendar-container", children: [_jsxs("div", { className: "calendar-header", children: [_jsxs("h2", { children: [monthNames[month], " ", year] }), _jsxs("div", { className: "calendar-button-group", children: [_jsx("button", { type: "button", className: "calendar-button", onClick: handlePrevMonth, children: "< Prev" }), _jsx("button", { type: "button", className: "calendar-button", onClick: handleToday, children: "Today" }), _jsx("button", { type: "button", className: "calendar-button", onClick: handleNextMonth, children: "Next >" })] })] }), _jsxs("div", { className: "calendar-grid", children: [dayLabels.map((day) => (_jsx("div", { className: "day-header", children: day }, day))), calendarCells.map((cell) => {
                        if (cell.isPadding) {
                            return _jsx("div", { className: "cell padding-cell" }, cell.key);
                        }
                        return (_jsxs("div", { className: `cell ${cell.isToday ? 'today' : ''}`, children: [_jsx("div", { className: "day-number", children: cell.dayNumber }), _jsx("div", { className: "events-list", children: cell.events?.map((event) => (_jsx("div", { className: `event-badge ${event.category || ''}`, children: event.url ? (_jsx("a", { href: event.url, children: event.title })) : (event.title) }, event.id))) })] }, cell.key));
                    })] })] }));
};
export default EventCalendar;
